export function createVideoUrl(playlistName, videoObject) {
  const categorySlug = playlistName.toLowerCase().replace(/ /g, '-');
  const videoName = videoObject.title
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[\]\\/]/gi, '');
  const videoId = videoObject.id;
  const videoSlug = `${videoName}-${videoId}`;
  const url = `/watch/${categorySlug}/${videoSlug}/`;

  return url;
}

export function createPlaylistUrl(playlistName) {
  const categorySlug = playlistName.toLowerCase().replace(/ /g, '-');
  const url = `/watch/${categorySlug}/`;

  return url;
}
